module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.popupItem) ? _c(_vm.popupItem.identify, {
    tag: "component",
    attrs: {
      "id": _vm.popupItem.identify,
      "info": _vm.popupInfo,
      "node": _vm.popupItem,
      "visible": _vm.showDialog
    },
    on: {
      "closed": _vm.closeWin
    }
  }) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5610bd78!./~/vue-loader/lib/selector.js?type=template&index=0!./src/part/car/order/popup.vue
// module id = 1253
// module chunks = 105